// extracted by mini-css-extract-plugin
export default {"container":"login_container__CP3Py","innerBox":"login_innerBox__4GV4E","footer":"login_footer__MTkuZ","error":"login_error__MCDsz"};